import React from 'react';
import styled from 'styled-components';
import { Page } from '~/components';
import TitleTooltip from './TitleTooltip';

// An Overview section is a settings page in its own right, so it is headed exactly as every other one is —
// the same `Page.TabHeader` and `Page.Title` the accounting ledgers, Team and Roles use.

const Section = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;

  /* The ledger pages get their gap below the title from Page.ListView's own top margin; a form brings none
     (Form.Control:first-child zeroes its padding), so the header carries it. */
  ${Page.TabHeader} {
    margin-bottom: 1.5rem;
  }
`;

export default function SettingsFormSection({ children, title, help, ...props }) {
  return (
    <Section {...props}>
      <Page.TabHeader>
        <Page.Title>{title}</Page.Title>
        {help && <TitleTooltip message={help} />}
      </Page.TabHeader>

      {children}
    </Section>
  );
}
